<ng-template [ngIf]="panelHeader">
  <!-- Composite form that references a form panel -->

  <!-- Needs to be the same as lm-richtext.component.html displayAsText -->
  <div *ngIf="panelHeaderRichTextVars"
    class="editor-container is-preview field panel-header-text">
    <h2
      class="lm-richtext-content is-preview hide-white-space input-full"
      data-options="{preview: true}"
      [innerHTML]="panelHeader | formatMessageRule:true:panelHeader:panelData:specFields"
      soho-editor
    ></h2>
  </div>

  <h2 *ngIf="!panelHeaderRichTextVars" class="panel-header-text">{{panelHeader | formatMessageRule:true:panelHeader:panelData:specFields}}</h2>
</ng-template>

<ng-template [ngIf]="panelText">
  <!-- Composite form that references a form, list, multilist panel -->

  <!-- Needs to be the same as lm-richtext.component.html displayAsText -->
  <div *ngIf="panelTextRichTextVars"
    [ngClass]="panelClass"
    class="editor-container is-preview field">
    <h4
      class="lm-richtext-content is-preview hide-white-space input-full"
      data-options="{preview: true}"
      [innerHTML]="panelText | formatMessageRule:true:panelText:panelData:specFields"
      soho-editor
    ></h4>
  </div>

  <h4 *ngIf="!panelTextRichTextVars" [ngClass]="panelClass">{{panelText | formatMessageRule:true:panelText:panelData:specFields}}</h4>
</ng-template>
